export default {"src":"/_next/static/media/cross.4458e504.svg","height":7,"width":6,"blurWidth":0,"blurHeight":0};